import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {TableExporterComponent} from './table-exporter.component';

@Injectable()
export class TableExporterService {

  constructor(private dialog: MatDialog) {
  }

  /**
   * Export table data.
   *
   * @param exportParams   - Export Params for the request.
   * @param type           - Type of export (e.g XLS, PDF).
   * @param exportUrl      - Url for the export request.
   */
  public export(exportParams: any, type: string, exportUrl: string) {
    const params = exportParams;
    params.type = type;
    this.dialog.open(TableExporterComponent, {
      data: {
        url: exportUrl,
        params
      }
    });
  }

}
